module.exports = __webpack_public_path__ + "static/media/kesiswaan.29d554c9.png";